import styled from 'styled-components';
import {CenteredDivWrap} from '../../../CommonStyleUtils/dwebCommon.styles';

export const Wrapper = styled.div``;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const CarouselSlider = styled.div`
  display: flex;
  overflow: hidden;
`;

export const SliderWrap = styled.div`
  backface-visibility: hidden;
  display: flex;
  touch-action: pan-y;
  width: 100%;
  // margin-left: calc((1rem) * -1);
`;

export const CarouselControls = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  top: ${props => props?.$topPosition || '50%'};
  transform: translateY(-50%);
}
`;

export const CarouselSlide = styled.div`
  flex: 0 0 100%;
  min-width: 0;
`;

export const CarouselIconWrapper = styled(CenteredDivWrap)<{isDisabled?: boolean}>(
  props => `
            width: 3rem;
            height: 3rem;
            cursor: pointer;
            margin: 0 0.5rem;
            border-radius:${props.theme.misc.borderRadius.round};
            background: rgba(0, 0, 0, 0.5);
            pointer-events: ${props.isDisabled ? 'none' : 'auto'};
            opacity: ${props.isDisabled ? 0.5 : 1};
            `,
);
